import NotesModal from './notes_modal.js'

export class CustomNotes {
  constructor (app) {
    this.app = app
    this.toolbarButtonElement = document.getElementById('customNotes')
    this.activeClass = 'toggled'
    this.notesMode = false
    this.modal = new NotesModal()
    this.notes = []

    this._bindEvents()
  }

  _bindEvents () {
    this.modal.onsave = evt => this._onModalSave(evt)
    this.modal.ondelete = evt => this._onModalDelete(evt)
    this.app.eventBus.on('deleteNote', evt => this._onModalDelete({id: evt.handle}))
    this.app.eventBus.on('documentloaded', (evt) => this._onDocumentLoaded(evt))
    this.app.eventBus.on('pagerendered', (evt) => this._onPageRendered(evt))
    this.toolbarButtonElement.addEventListener('click', (evt) =>
      this._onToolbarButtonClicked(evt))
  }

  _onDocumentLoaded () {
    if (this.app.api.operating()) {
      this._fetchNotes()
      this._initPage()
      this.toolbarButtonElement.classList.remove('hidden')
    } else {
      this.toolbarButtonElement.classList.add('hidden')
    }

  }

  _initPage () {
    const pageIndex = this.app.pdfViewer.currentPageNumber - 1
    const page = this.app.pdfViewer.getPageView(pageIndex)
    const pageElement = page.div
    const pageRect = pageElement.getBoundingClientRect()

    pageElement.addEventListener('click', (evt) => {
      if (!this.notesMode && !this.modal.isOpened()) {
        return
      }

      if (this.modal.isOpened()) {
        this.modal.close()
        return
      }

      const pdfPoint = this._pdfPoint(
        evt.x,
        evt.y
      )

      const domPoint = this._domPoint(
        pdfPoint.x,
        pdfPoint.y
      )

      console.log(pageRect)
      this.modal
        .at(domPoint.x + pageRect.x, domPoint.y)
        .withText('')
        .withPayload({
          id: null,
          x: pdfPoint.x,
          y: pdfPoint.y,
          page: this.app.pdfViewer.currentPageNumber
        })
        .edit()
    });
  }

  _fetchNotes () {
    this.notes = []
    this.app.secondaryToolbar.clearNotes()
    this.app.api.getNotes().then(notes => {
      notes.forEach(note => {
        this._addNote(note)
      })
      this._renderNoteMarks()
    })
  }

  _onModalSave (note) {
    if (note.id) {
      this.app.api.updateNote(note).then(() => {
        this._fetchNotes()
      })
    } else {
      this.app.api.addNote(note).then(() => {
        this._fetchNotes()
      })
    }
  }

  _onModalDelete (note) {
    console.log('deleting', note)
    this.app.api.deleteNote(note.id).then(() => {
      this._fetchNotes()
    })
  }

  _onPageRendered () {
    this._initPage()
    this._renderNoteMarks()
  }

  _addNote (note) {
    this.notes.push(note)
    this.app.secondaryToolbar.addNote(note.id, note.text)
  }

  _renderNoteMarks () {
    document.querySelectorAll('.note-mark').forEach(e => {
      e.remove()
    })

    this.notes.forEach(note => {
      if (note.page != this.app.pdfViewer.currentPageNumber) {
        return
      }

      const noteEl = document.createElement('div')
      noteEl.classList.add('note-mark')
      const domPoint = this._domPoint(note.x, note.y)
      noteEl.setAttribute('style', `top: ${domPoint.y-8}px; left: ${domPoint.x-8}px`)
      noteEl.addEventListener('click', (evt) => {
        evt.preventDefault()
        evt.stopPropagation()
        const domPoint = this._domPoint(note.x, note.y)
        this.modal
          .at(domPoint.x, domPoint.y)
          .withText(note.text)
          .withPayload({
            id: note.id,
            x: note.x,
            y: note.y,
            page: note.page
          })
          .display()
      })

      const page = this.app.pdfViewer.getPageView(note.page-1);
      const pageElement = page.div;
      pageElement.querySelector(".textLayer").appendChild(noteEl);
    })
  }

  _pdfPoint (domX, domY) {
    const pageIndex = this.app.pdfViewer.currentPageNumber - 1
    const page = this.app.pdfViewer.getPageView(pageIndex)
    const pageRect = page.canvas.getClientRects()[0]
    const viewport = page.viewport
    const point = viewport.convertToPdfPoint(
      Math.max(domX, 0) - pageRect.x,
      Math.max(domY, 0) - pageRect.y
    )
    return {x: point[0], y: point[1]}
  }

  _domPoint (pdfX, pdfY) {
    const pageIndex = this.app.pdfViewer.currentPageNumber - 1
    const page = this.app.pdfViewer.getPageView(pageIndex)
    const pageRect = page.canvas.getClientRects()[0]
    const viewport = page.viewport
    const point = viewport.convertToViewportPoint(
      Math.max(pdfX, 0),
      Math.max(pdfY, 0)
    )
    return {x: point[0], y: point[1]}
  }

  _onToolbarButtonClicked () {
    if (this.notesMode) {
      this._exitNotesMode()
    } else {
      this._enterNotesMode()
    }
  }

  _enterNotesMode () {
    this.notesMode = true
    this.toolbarButtonElement.classList.add(this.activeClass)
  }

  _exitNotesMode () {
    this.notesMode = false
    this.toolbarButtonElement.classList.remove(this.activeClass)
  }
}
